import DataTable from 'react-data-table-component';
// import PlanningAddspec from '../planning/planningcomponent/planningAddspec';
import Actionplanning from '../planning/planningcomponent/actionplanning';
import React from 'react'


const columns = [
    {
        name: 'TDS code',
        sortable: true,
         grow: 0.7,
        selector: row =>row.tdscode,
    },
    {
        name: 'V',
        grow: 0.1,
        selector: row => row.revision,
    },
    {
        name: 'Journal Type',
        selector: row => 
            <div>
                <div>:{row.journaltype}</div>
                <div>:{row.customername}</div>
                <div>:{row.productname}</div>
                </div>
    },
    {
        name: 'product grouptype',
        selector: row => <div >
            {row.productgrouptype}
            <div style={{color:'#E85107'}}>Create by : {row.createbyName}</div>
            </div>,
    },
   
    {
        name: 'createdate',
        selector: row => row.createdate,
    },
    {
        name: 'Action',
         grow: 1.5,
        cell: row =><Actionplanning journalId={row.journalId} codeid={row.tdscode} stateflow={row.stateflow} totalspec={row.totalspec}/>,
    },

];

const customStyles = {
    headRow: {
        style: {
            border: 'none',
            backgroundColor: '#28B463'
        },
    },
    headCells: {
        style: {
            color: '#ffff',
            fontSize: '14px',
        },
    },
    rows: {
        highlightOnHoverStyle: {
            backgroundColor: 'rgb(230, 244, 244)',
            borderBottomColor: '#FFFFFF',
            borderRadius: '25px',
            outline: '1px solid #FFFFFF',
        },
    },
    pagination: {
        style: {
            border: 'none',
        },
    },
};



const Journaltable = ({datatable}) => {
    var dataresult = datatable;


    return (
    
        <DataTable
            columns={columns}
            data={dataresult}
            // selectableRows
            pagination
            customStyles={customStyles}
            highlightOnHover

        />
    )
}

export default Journaltable